<div class="py-20 bg-light">
  <div class="container mx-auto px-6 max-w-lg text-center">
    <div class="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-lg dark:shadow-slate-900/50 border">
      <div class="flex justify-center mb-4">
        <svg class="h-16 w-16 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <h2 class="text-3xl font-bold text-secondary mb-2">Inscription presque terminée !</h2>
      <p class="text-gray-600 dark:text-gray-400">
        Nous vous avons envoyé un e-mail de vérification à l'adresse que vous avez fournie.
      </p>
      <p class="text-gray-600 dark:text-gray-400 mt-2">
        Veuillez cliquer sur le lien qu'il contient pour activer votre compte.
      </p>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-6">
        Vous n'avez pas reçu l'e-mail ? Vérifiez votre dossier de spam ou
        <button (click)="resendVerificationEmail()"
          [disabled]="isResending"
          class="text-primary hover:underline disabled:text-gray-400">
          cliquez ici pour le renvoyer
        </button>.
      </p>

      @if (resentMessage) {
        <p class="mt-4 text-green-600 dark:text-green-400 font-semibold">
          {{ resentMessage }}
        </p>
      }
    </div>
  </div>
</div>
